// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"4f35a807","537":"06a5b00a"}[chunkId] + ".chunk.css";
};